<template>
  <div class="box7">
    <pageTitle
      title="学完后可以胜任的岗位"
      titleColor=" #081745"
     
    />

    <div class="subject-content">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
          :class="'block' + (index + 1)"
        >
          <div class="block">
            <div class="title">{{ item.title }}</div>
            <p>{{item.p}}</p>
            <div class="img">
              <img
              :src="
                require(`../../../assets/coursePage/ai2/box7/img0${
                  index + 1
                }.png`)
              "
              alt
            />
            </div>
            
          </div>
        </swiper-slide>
        <div class="seat"></div>
      </swiper>
      <!-- <div class="swiper-pagination-box2"></div> -->
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},
  data() {
    return {
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        // centeredSlides: true,
        // paginationClickable: true,
        // spaceBetween: 20,
        // effect: "left",
        pagination: {
          el: ".swiper-pagination-box2",
        },
      },
      list: [
        {
          title: "Prompt工程师",
          p:'负责Prompt生产过程的制定，反复迭代语言表达，达到模型最佳理解效果；进行数据分析、对Prompt模板进行调优等；深入理解实际业务场景需求，完成Prompt模板创作。'
        },
        {
          title: "大模型应用开发工程师",
          p:'负责基于大语言模型技术的应用开发，对接业务需求，和产品、策划团队紧密配合实现高质量的技术方案；接入和测试评估多种不同大语言模型，根据业务的需求选用最合适的大语言模型；追踪大语言模型技术的发展，更新知识，了解最新的玩法和特性。'
        },
        {
          title: "大模型训练推理开发工程师",
          p:'负责跟进大模型最近的进展，结合业务领域的特点，训练垂类大模型；追踪前沿技术，并进行模型创新，合理的运用在业务中，优化业务指标；利用LLM前沿技术方向，负责AI内容生成和编辑、内容理解和质量识别、场景应用等。'
        },
        {
          title: "大模型算法专家",
          p:'负责将大模型技术应用于垂类领域，推动大模型技术发挥业务价值，并提供可规模复制的产品解决方案；追踪学术界和工业界在大模型预训练、微调、强化学习等方向的前沿进展，并进行持续创新和优化； 解决大模型产业落地过程中的算法和工程技术难题。'
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box7 {
  padding: 80px 0 80px;
  width: 100%;
  background: url("../../../assets/coursePage/ai2/box7/bg.png") no-repeat;
      background-size: cover;
      background-position: center;
  .subject-content {
    position: relative;
    margin-top: 48px;

    width: 100%;
    box-sizing: border-box;
  }
  .seat {
    width: 32px;
    flex-shrink: 0;
  }
  .swiper-wrapper {
    width: 100%;
  }
  .swiper-slide {
    margin-left: 32px;
    width: 560px;
height: 666px;
padding-top: 60px;
    border-radius: 20px;
    border: solid 2px transparent;
   
    box-sizing: border-box;
    flex-shrink: 0;
  }

  .block {
    position: relative;
    flex-shrink: 0;
    padding:92px 38px 40px;
   
    width: 100%;
    height: 100%;
    
background: rgba(255,255,255,0.8);
border-radius: 52px;
    box-sizing: border-box;
    background: rgba(255,255,255,0.8);
    p{
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
font-size: 28px;
color: #4E5969;
line-height: 52px;
text-align: center;
font-style: normal;
    }
    .img {
      position: absolute;
      top: -60px;
      left: 50%;
      transform: translateX(-50%);
      width: 120px;
      background: #FFFFFF;
border-radius: 24px;
height: 120px;
display: flex;
align-items: center;
justify-content: center;
      img{
        width: 80px;
      height: 80px;
      }
    }
    .title {
      margin-bottom: 24px;
      font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 32px;
color: #1D2129;
line-height: 52px;
text-align: center;
font-style: normal;
    }

    
  }

  

  .swiper-pagination-box2 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #d7effe;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #2ea5fc;
    border-radius: 3px;
  }
}
</style>
